:host {
    display: grid;
    grid-template-columns: var(--ux-table-col-template, repeat(var(--ux-head-cell-count), minmax(var(--ux-table-col-min-width), 1fr)));
}

:host(:hover) {
    ::slotted(ux-table-cell-neo:not([head])) {
        background-color: $color-blue-hover;
    }
}

:host([head]) {
    ::slotted(ux-table-cell-neo:first-of-type) {
        border-inline-start: none;
    }

    ::slotted(ux-table-cell-neo:last-of-type) {
        border-inline-end: none;
    }
}